<template>
    <div class="level-container">
      <div class="bar-container"">
        <div class="max-level">{{ maxLevel }} m</div>
    
        <div class="bar">
          <div
            v-for="(item, index) in steps"
            :key="index"
            :class="['step',getStepColor(item),]"
            :style="{ width: index == 19 || index == firstRedBar ? '150%' : '100%',opacity: index > currentStepIndex ? '25%' : '100%'}"
          ></div>
    
          <!-- Nível atual -->
          <div
            class="current-level" 
            :style="{ bottom: currentStepIndex < 19 ? currentLevelPercent + '%' : currentLevelPercent - 6 + '%'  }"
          >
            <div class="info-bar" :style="{ color: currentStepIndex < 5 ? '#FF6060' : '#4092FF' }">
              {{ parseFloat(currentVolume).toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 2 }) }} {{ unitLegend() }} /
              {{ parseFloat(maxVolume).toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).toLocaleString() }} {{ unitLegend() }}
              <div class="arrow"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
import { string } from 'check-types';

  export default {
    name: "LevelBar",
    props: {
      maxLevel: { type: Number, required: true },
      currentLevel: { type: String, required: true },
      minimumLevel: { type: Number, required: true },
      maxVolume: { type: String, required: true },
      currentVolume: { type: String, required: true },
      unitMeasure:{type: String},
    },
    computed: {
      steps() {
        const count = 21; // total de marcas
        return Array.from({ length: count }, (_, i) => ({
          pos: (i / (count - 1)) * this.maxLevel
        }));
      },
      currentLevelPercent() {
        return (this.currentVolume / this.maxVolume) * 100;
      },
      currentStepIndex() {
        // índice (0..19) correspondente ao nível atual
        return Math.round((this.currentVolume / this.maxVolume) * (20 - 1));
      },
      firstRedBar() {
        for (let i = this.steps.length - 1; i >= 0; i--) {
          if (this.getStepColor(this.steps[i]) === 'red') {
            return i;
          }
        }
        return -1; 
      }
    },
    methods: {
      getStepColor(step) {
        return step.pos >= this.minimumLevel ? "blue" : "red";
      },
      unitLegend(){
        return this.unitMeasure === 'm3' ? 'm³' : 'L';
      }
    }
  };
  </script>
  
  <style scoped>
  .level-container {
    display: flex;
    align-items: center;
  }

  .bar-container{
    background-color: white;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 10px;
    box-shadow: 6px 6px 54px 0 rgba(0, 0, 0, 0.05);
    padding: 10px;
    gap: 8px;
  }
  
  .max-level {
    margin-bottom: 5px;
  }
  
  .bar {
    
    align-items: center;
    position: relative;
    width: 16px;
    height: 200px;
    display: flex;
    flex-direction: column-reverse;
    justify-content: space-between;
    z-index: 1;
  }
  
  .step {
    height: 4px;
    width: 100%;
    border-radius: 12px;
    transition: all 0.2s ease;
  }
  
  .blue {
    background-color: #4092FF;
  }
  
  .red {
    background-color: #FF6060;
  }
  
  .current-level {
    position: absolute;
    left: 40px;
    transform: translateY(50%);
  }
  
  .info-bar {
    background: white;
    border-radius: 10px;
    gap: 4px;
    padding: 6px 10px;
    box-shadow: 6px 6px 54px 0 rgba(0, 0, 0, 0.05);
    font-size: 0.75rem;
    white-space: nowrap;
    position: relative;
    justify-content: center;
    align-items: center;
  }
  
  .arrow {
    content: "";
    position: absolute;
    left: -6px;
    top: 50%;
    transform: translateY(-50%);
    width: 0;
    height: 0;
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
    border-right: 6px solid white;
    z-index: 2;
   
  }
  
  .arrow::after {
    content: "";
    position: absolute;
    left: -1px;
    top: -5px;
    width: 0;
    height: 0;
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
    border-right: 6px solid white;
    z-index: 2;
   
  }
  </style>
  